import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputWithTitle, ROUNDED_BUTTON_TYPE, RoundedButton } from './common';
import { OtpHeaderStep } from './OtpHeaderStep';
import { CodeReSentNotification } from './CodeReSentNotification';

import { useAuthorizationCode } from './hooks';
import { maskEmail } from './utils';

import styles from './EnterAuthorizationCode.module.css';

const EnterAuthorizationCode = ({
  email = '',
  setCurrentStep = () => { },
  certificateNumber = '',
}) => {
  const { t } = useTranslation('petDemos');
  const {
    authCode,
    codeReSent,
    error,
    handleInputChange,
    handleResendCode,
    handleSubmit,
    isLoading,
    remainingSeconds,
  } = useAuthorizationCode({ certificateNumber, email, setCurrentStep });

  return (
    <div className={styles.mainContainer}>
      <OtpHeaderStep email={maskEmail(email)} />

      <form className={styles.form} onSubmit={handleSubmit}>
        <InputWithTitle
          disabled={isLoading}
          error={error}
          name="verificationCode"
          onChange={handleInputChange}
          placeholder={t('certificateLinking.'
            + 'authorizationCodeScreen.placeholder')}
          title={t('certificateLinking.'
            + 'authorizationCodeScreen.verificationCode')}
          type="number"
          value={authCode}
        />

        {codeReSent && <CodeReSentNotification />}

        <div className={styles.buttonsContainer}>
          <RoundedButton
            buttonType={ROUNDED_BUTTON_TYPE.WHITE}
            disabled={isLoading || remainingSeconds > 0}
            isSubmitType={false}
            label={remainingSeconds > 0
              ? t('certificateLinking.authorizationCodeScreen.resendCodeIn', {
                seconds: remainingSeconds,
              })
              : t('certificateLinking.authorizationCodeScreen.resendCode')}
            onClick={handleResendCode}
          />

          <RoundedButton
            buttonType={ROUNDED_BUTTON_TYPE.BLUE}
            disabled={isLoading || !authCode}
            isSubmitType
            label={t('certificateLinking.authorizationCodeScreen.verify')}
            loading={isLoading}
          />
        </div>
      </form>
    </div>
  );
};

export { EnterAuthorizationCode };
